export function getUnreadCount(message) {
  const raw =
    message?.sum_status ??
    message?.unread_count ??
    message?.unread_messages_count ??
    0;
  const count = Number(raw);
  return Number.isFinite(count) && count > 0 ? count : 0;
}

export function getUnreadBadgeLabel(count) {
  const value = Number(count || 0);
  if (!Number.isFinite(value) || value <= 0) return "";
  return value > 99 ? "99+" : String(value);
}

export function getTotalUnreadCount(messages = []) {
  return (messages || []).reduce((sum, item) => sum + getUnreadCount(item), 0);
}
